function toUrlString(input) {
  return input
    .trim()
    .toLowerCase()
    .replace(/[ä]/g, 'ae')
    .replace(/[ü]/g, 'ue')
    .replace(/[ö]/g, 'oe')
    .replace(/[ß]/g, 'ss')
    .replace(/[^a-z0-9_]+/gi, '-')
    .replace(/^-|-$/g, '');
}

function isAddressCoordinates(address) {
  return address.match(/[0-9.]+,[0-9.]+/);
}

module.exports = { toUrlString, isAddressCoordinates };
